import useTranslation from '@space-lib/hooks/useTranslation'

import { SubTitle } from './styles'

const HeaderAccessAndPrivacy = () => {
  const { t } = useTranslation()

  return (
    <>
      <p className='_text-gray-900 _font-weight-light _text-5 _mb-7'>
        {t('configuration_sidebar.access_and_privacy.title')}
      </p>
      <SubTitle className='_font-weight-bold _text-gray-900 _mb-2'>
        {t('configuration_sidebar.access_and_privacy.sub_title')}
      </SubTitle>
    </>
  )
}

export default HeaderAccessAndPrivacy
